import { createFileRoute } from "@tanstack/react-router";
import { AppNav } from "@/components/AppNav";
import { FaqBody } from "@/components/FaqBody";
import faqContent from "../../docs/faq.md";

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [{ title: "Perguntas frequentes — Busca Blindados" }],
  }),
  component: FaqPage,
});

function FaqPage() {
  return (
    <div className="min-h-screen text-foreground">
      <AppNav />
      <main className="mx-auto max-w-3xl px-6 pb-32 pt-6">
        <FaqBody blocks={faqContent.blocks} />
      </main>
    </div>
  );
}
